import React from 'react';
import { FiBriefcase, FiSearch, FiFileText, FiArrowRight } from 'react-icons/fi';

// A smaller, reusable component for each activity item
const ActivityItem = ({ icon, count, title }) => (
    <div className="flex items-center justify-between shadow-style p-3 rounded-lg">
        <div className="flex items-center gap-3 text-gray-666">
            <div>{icon}</div>
            <span className="font-bold text-gray-333">{count}</span>
            <span className="text-xs">{title}</span>
        </div>
        <button className="text-xs font-semibold text-gray-999 flex items-center gap-1">
            View details 
            <span className="inline-flex items-center shadow-md justify-center w-5 h-5 rounded-full bg-white ml-1">
                <FiArrowRight size={12} />
            </span>
        </button>
    </div>
);

const ActivitySummaryCard = ({ activity }) => {
  return (
    <div className="rounded-2xl shadow-style p-6 mt-8">
      <h4 className="font-bold text-sm text-gray-333 mb-4">Quick Look at Your Activity</h4>
      <div className="space-y-3">
        <ActivityItem icon={<FiBriefcase className="mph-primary" />} title="Job matches" count={activity.job_matches} />
        <ActivityItem icon={<FiSearch className="mph-primary" />} title="Search appearances" count={activity.search_appearances} />
        <ActivityItem icon={<FiFileText className="mph-primary" />} title="Applications" count={activity.applications} />
      </div>
    </div>
  );
};

export default ActivitySummaryCard;